import React, {FunctionComponent} from "react";
import WizardStep from "../../WizardStep";
import statusBrand from "../../../../images/Progress/progress_marke.svg";
import UncertainInput from "../../../../commonComponents/UncertainInput";
import {Step} from "../../../WizardMap";
import {ValidatorForm} from "react-material-ui-form-validator";
import {isUncertainInfoEmpty} from "../../../state/utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../redux/rootReducer";
import {setBrandValue, toggleBrandUnknown} from "../../../state/disposalSlice";
import {NavigationProps} from "../../../slideRouter/navigationHook";

const StepWatchBrand: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const dispatch = useDispatch();
    const {currentDisposal: {brand}} = useSelector((state: RootState) => state.disposal);

    return (
        <WizardStep
            title={"Um welche Marke handelt es sich?"}
            icon={statusBrand}
            backButton={true}
            onBackClick={gotoPrevSlide}
            nextButton={true}
            nextButtonDisabled={isUncertainInfoEmpty(brand)}
            onNextClick={() => gotoNextSlide(Step.WATCH_MODEL)}
        >
            <ValidatorForm onSubmit={() => !isUncertainInfoEmpty(brand) && gotoNextSlide(Step.WATCH_MODEL)}>
                <UncertainInput
                    textInputLabel={"Marke"}
                    textInputValue={brand ? brand.value : ""}
                    inputDisabled={brand && brand.unknown}
                    onChangeText={(text: string) => dispatch(setBrandValue(text))}
                    checkBoxLabel={"Unbekannt"}
                    checkboxChecked={brand && brand.unknown}
                    onCheckBoxClick={() => dispatch(toggleBrandUnknown())}
                />
            </ValidatorForm>
        </WizardStep>
    );
};

export default StepWatchBrand;
